import { render, staticRenderFns } from "./CampaignDetail.vue?vue&type=template&id=fbad9eb6&scoped=true&"
import script from "./CampaignDetail.vue?vue&type=script&lang=js&"
export * from "./CampaignDetail.vue?vue&type=script&lang=js&"
import style0 from "./CampaignDetail.vue?vue&type=style&index=0&id=fbad9eb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbad9eb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbad9eb6')) {
      api.createRecord('fbad9eb6', component.options)
    } else {
      api.reload('fbad9eb6', component.options)
    }
    module.hot.accept("./CampaignDetail.vue?vue&type=template&id=fbad9eb6&scoped=true&", function () {
      api.rerender('fbad9eb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/CampaignDetail.vue"
export default component.exports